var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "19px",
    height: "28px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -202 -18 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 26.633932594975914  C 19 26.633932594975914  19 18.37752316567837  19 18.37752316567837  C 17.72967558816829 20.245499127080684  15.639382513716859 21.444625014837285  13.28405393787566 21.444625014837285  C 9.394397227277905 21.444625014837285  6.219106406577773 18.12547688359963  6.219106406577773 13.998908451355884  C 6.219106406577773 9.899617809322965  9.368514398025471 6.553191367593908  13.28405393787566 6.553191367593908  C 15.639382513716859 6.553191367593908  17.70275752473358 7.752318165841513  19 9.621385285677514  C 19 9.621385285677514  19 1.3660664945330776  19 1.3660664945330776  C 17.280351370584267 0.4735405832597941  15.348460480520355 0  13.28405393787566 0  C 5.95406473426417 0  0 6.274959364229032  0 14  C 0 21.725040635770966  5.95406473426417 28  13.28405393787566 28  C 15.321542540504126 28  17.25343330714956 27.498089687674824  19 26.633932594975914  Z ",
    fillRule: "nonzero",
    fill: "#d80020",
    stroke: "none",
    transform: "matrix(1 0 0 1 202 18 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.0f1b842c688f668c16409cafa5bbe1b1.svg";
export { ForwardRef as ReactComponent };